import servicesIaFormModel from './servicesIaFormModel';

const {
  formField: {
    provider,
    serviceType,
    name,
    code,
    description,
    apiVersion,
    currency,
    inputPrice,
    outputPrice,
    cachePrice,
    contextWindow,
    maxOutputTokens,
    sortOrder,
  },
} = servicesIaFormModel;

export default {
  [provider.name]: undefined,
  [serviceType.name]: undefined,
  [name.name]: '',
  [code.name]: '',
  [description.name]: '',
  [apiVersion.name]: '',
  [currency.name]: undefined,
  [inputPrice.name]: '',
  [outputPrice.name]: '',
  [cachePrice.name]: '',
  [contextWindow.name]: '',
  [maxOutputTokens.name]: '',
  [sortOrder.name]: '',
};
